<script setup>
import Header from './Header.vue';
import Footer from './Footer.vue';
import { CheckCircle2, ArrowRight } from 'lucide-vue-next';
import { useRouter } from 'vue-router';
const router = useRouter();
</script>

<template>
  <div class="min-h-screen bg-gradient-to-b from-white to-black/5">
    <Header />

    <div class="container min-h-screen mx-auto px-4 pt-32 pb-16 flex items-center justify-center">
      <div class="max-w-2xl mx-auto w-full">
        <!-- Success Card -->
        <div
          class="bg-white border border-black/5 rounded-2xl p-10 shadow-lg transform transition-all duration-500 hover:shadow-xl"
        >
          <!-- Success Icon -->
          <div class="flex justify-center mb-8">
            <div class="bg-green-100 p-4 rounded-full animate-pulse">
              <CheckCircle2 class="w-16 h-16 text-green-600" />
            </div>
          </div>

          <!-- Success Message -->
          <h1 class="text-3xl font-bold text-center text-black/90 mb-4 tracking-tight">
            {{ $t('success.title') }}
          </h1>
          <p class="text-black/60 text-center text-lg mb-10 max-w-md mx-auto leading-relaxed">
            {{ $t('success.description') }}
          </p>

          <!-- Action Buttons -->
          <div class="flex flex-col sm:flex-row gap-5 justify-center">
            <button
              @click="router.push('/create')"
              class="px-8 py-2 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all duration-300 font-medium text-base shadow-md hover:shadow-lg flex items-center justify-center gap-2 group transform hover:scale-105"
            >
              {{ $t('success.createNew') }}
              <ArrowRight class="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <Wechat :default-show="true" :vip="true" /> -->

    <Footer />
  </div>
</template>
